import RatesTab from './RatesTab'
export default RatesTab


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/HWTab/MappingTabs/RatesTab/index.js